/**
 * The ergonomics gate, measured. The plan's success criterion is not correctness but speed:
 * if this ticket is slower than cTrader's native one, nobody uses it. Every trade through the
 * ticket records how long it took from open to send and from send to fill, and posts it so the
 * numbers are read off the API's log rather than off a phone screen.
 */
export interface TicketTiming {
  openedAt: number
  firstVerdictAt: number | null
  sentAt: number | null
  filledAt: number | null
}

export function startTiming(now: () => number = () => performance.now()): TicketTiming {
  return { openedAt: now(), firstVerdictAt: null, sentAt: null, filledAt: null }
}

export function summarise(timing: TicketTiming): Record<string, number | null> {
  const delta = (a: number | null, b: number | null) => (a === null || b === null ? null : Math.round(b - a))
  return {
    openToFirstVerdictMs: delta(timing.openedAt, timing.firstVerdictAt),
    openToSendMs: delta(timing.openedAt, timing.sentAt),
    sendToFillMs: delta(timing.sentAt, timing.filledAt),
    openToFillMs: delta(timing.openedAt, timing.filledAt),
  }
}
